import { Subject } from 'rxjs/Subject';
import { PaperSize, WhiteSheet, Circle, Rectangle, Angle, Dimensions, Text, DoublePost, TerminationPost, SelectablePicket, SelectableIntermediatePost, SingleCornerPost } from './object3D';
import { common } from './common';
import { TitleBlock } from './object3D/TitleBlock/TitleBlock';
import { BehaviorSubject } from 'rxjs';

declare let THREE: any;

class Scene extends (THREE.Object3D as { new(): any }) {
  private zIndex = 0;

  constructor() {
    super();
    this.name = 'ProToolsDrawings';
  }

  add(...objects) {
    if (objects.length === 0) {
      return;
    }
    this.zIndex += 1;
    objects.forEach(o => (o.position.y = this.zIndex + common.startAtY));
    super.add(...objects);
  }

  getObjectByName(name) {
    const obj = this.children.filter(ch => ch.name == name)[0];
    return obj;
  }

  clear() {
    this.zIndex = 0;
    this.remove(...this.children);
  }

  getZIndex() {
    return this.zIndex;
  }
}

export class DrawingsHolderService {
  private _canvas: Scene;
  public readonly onSelect = new BehaviorSubject<any>([]);
  public saved = new Subject<boolean>();
  private sheet: WhiteSheet;
  public scale: any;
  public paperWidth: number;
  public paperHeight: number;

  constructor() {
    this._canvas = new Scene();
    this.sheet = new WhiteSheet();
  }

  get canvas() {
    return this._canvas;
  }

  setSaved(value) {
    this.saved.next(value);
  }

  initialize() {
    // this._canvas.clear();
    this._canvas.add(this.sheet);
    this.sheet.position.y = common.startAtY;
  }

  getEditableItems() {
    let items = [];
    let titleBlockActive = false;
    this._canvas.children.forEach(ch => {
      if (ch.name === "PolyLine"
        || ch.name === "Arc"
        || ch instanceof Circle
        || ch instanceof Rectangle
        || ch instanceof Angle
        || ch instanceof Text
        || ch.modifiedAtStep3
        // || ch instanceof Dimensions
        // || ch instanceof DoublePost
        // || ch instanceof TerminationPost
        // || ch instanceof SelectablePicket
        // || ch instanceof SelectableIntermediatePost
        // || ch instanceof SingleCornerPost
        ) {
        let info = ch.getInfo();
        items.push(info);
      }
      if (ch instanceof TitleBlock) {
        titleBlockActive = true;
      }
    });

    return {
      items: items,
      activeTB: titleBlockActive
    };
  }

  getTitleBlockInfo() {
    let info = undefined;
    this._canvas.children.forEach(ch => {
      if (ch instanceof TitleBlock) {
        info = ch.info;
      }
    });
    return info;
  }

  get paperBox(): PaperSize {
    let paperSize = this._canvas.getObjectByName(PaperSize.Name);
    if (!paperSize) {
      paperSize = new PaperSize();
      this._canvas.add(paperSize);
    }
    return paperSize;
  }

  clear() {
    this._canvas.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/drawings-holder.service.ts